<template>
<div class="chapter">
<div class="inner_page">
<p class="imagex"><a id="page_xviii"></a><a id="map"></a><img alt="image" src="images/fxviii-01.jpg"/></p>
<p class="captionx">Map of the Kovno area (<em>above</em>) and detail of the Kovno ghetto (<em>facing</em>), marking the locations of significant events mentioned in the text. The River Neris is locally known also as the Vilija River. <em>Both maps courtesy of the United States Holocaust Memorial Museum</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?30c275de